import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DrillsService, GetDrillByIdResponse } from '@drills/infra';
import { toDrillDetailViewModel } from '../../../mappers';
import { DrillDetailQueryResult } from './drill-detail.query-result';

export class DrillDetailQueryHandler {
  private readonly drillsService: DrillsService = inject(DrillsService);

  query(drillId: string): Observable<DrillDetailQueryResult> {
    return this.drillsService
      .getOne(drillId)
      .pipe(map((dto: GetDrillByIdResponse) => ({ drill: toDrillDetailViewModel(dto) })));
  }
}
